
<template>
  <v-list-item v-if="artist !== null">
    <v-list-item-icon>
      <slot name="button" />
    </v-list-item-icon>
    <v-list-item-avatar class="mr-4">
      <img :src="artist.images[0].url" />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-html="artist.name"></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import cms from '../../cms'

@Component
export default class BuilderArtistTile extends Vue {
  @Prop() value!: string

  artist: {
    images: { url: string }[]
    name: string
  } | null = null

  created () {
    this.watchQuery(this.value)
  }

  @Watch('value')
  async watchQuery (value: string) {
    if (this.value === '') {
      this.$emit('input', '')
      return
    }

    try {
      const artist = await cms.api.spotify.getArtist(value)

      if (artist) {
        this.artist = artist

        this.$emit('input', this.value)
      }
    } catch (e) {
      alert('Artist not found')
    }
  }
}
</script>

<style scoped></style>
